import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { PipelineDashboardData } from 'src/Models/pipeline.model';
import { Observable } from 'rxjs';
import { helperFunctions } from 'src/helperfunctions';

@Injectable({
  providedIn: 'root'
})
export class PipelineService {
  private URL:string = environment.pipeline.pipelineDashboard_URL;

  constructor(private http: HttpClient, private helper:helperFunctions ) { }

  private PipelineDashboardData(startDate:string, endDate:string, loggedInUserID:string, selectAllStages:boolean, consultantList?:string[], countryList?:string[], officeList?:string[]){
    let body = {
      "startDate": startDate,
      "endDate": endDate,
      "consultantList": consultantList,
      "countryList": countryList,
      "officeList": officeList,
      "loggedInUserID": loggedInUserID,
      "allStages": selectAllStages
    }
    return this.http.post<any>(this.URL, body);
  }

  public getPipelineData(loggedInUserID:string, selectAllStages:boolean,  startDate?:Date | null, endDate?:Date | null, consultantList?:string[], countryList?:string[], officeList?:string[] ):Observable<PipelineDashboardData[]>{
    return this.PipelineDashboardData(this.helper.dateToString('yyyy-MM-dd', startDate), this.helper.dateToString('yyyy-MM-dd', endDate),loggedInUserID, selectAllStages, consultantList, countryList, officeList)
    .pipe(map((data:any) => data.response_object));
  }

  public PipelineDashboardSecurity(id: string):Observable<any>{ //ToDo: update url
    let headers = { 'skip': 'false' , 'Content-Type': 'application/json'};
    let body = {
      "tokenId": id,
      "systemId": environment.pipeline.systemId
    }
    return this.http.post<any>(environment.pipeline.pipelineDashboardSecurity_URL, body, { 'headers': headers }).pipe(map((data:any) => data.response_object));
  }
}
